<template>
  <div class="Footer">
    <router-link to="/" class="logo">
      <img :src="inverted ? logoOutline : logo" />
    </router-link>
    <div class="footer-boxes">
      <div class="footer-box">
        <div :class="['description', 'a-hover', { 'a-grey': !inverted }]" v-if="site" v-html="site.footer"></div>
      </div>
      <div class="footer-box-middle">
        <vue-link :to="link.url" v-for="link in links" :key="link.url" :class="{
          active: $route.meta.active === link.url,
        }">
          <span>{{ link.title }}</span>
        </vue-link>
      </div>
      <div class="footer-box-middle">
        <a href="/supporters#supporter-circle"><span>Supporters Circle</span></a>
        <a href="/supporters#major-donors"><span>Major Donors</span></a>
        <a href="/supporters#sponsor"><span>Sponsorship</span></a>
        <a href="/support"><span>Membership</span></a>
        <a href="https://shop.dublab.com/products/dublab-donation"><span>Donate</span></a>
      </div>
      <div class="footer-box">
        <div v-if="site" class="link-list">
          <div v-for="link in site.social_links" :key="link.url">
            <a :href="link.url" class="hover">{{ link.text }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueLink from "./VueLink.js";
import logo from "@/assets/images/logo-type.svg";
import logoOutline from "@/assets/images/logo-type-outline.svg";

export default {
  name: "Footer",
  components: { VueLink },
  data() {
    return {
      logo,
      logoOutline,
    };
  },
  props: {
    inverted: {
      default: false,
    },
  },
  computed: {
    site() {
      return this.$store.getters.getPage("star");
    },
    links() {
      if (!this.site) return [];
      return this.site.navigation;
    },
  },
};
</script>

<style scoped>
.Footer {
  padding: 6rem 0rem 0rem 0rem;
  position: relative;
}

.footer-boxes {
  display: flex;
  margin-top: 3rem;
}

.footer-box {
  height: 200px;
  width: 25%;
  border-top: 1px solid black;
  border-right: 1px solid black;
  font: var(--small_mono);
  padding: 1%;
  padding-right: 4%;
}

.footer-box-middle {
  height: 200px;
  width: 16%;
  border-top: 1px solid black;
  border-right: 1px solid black;
  padding: 1%;
  display: flex;
  flex-direction: column;
  font: var(--small_mono);
}

.footer-box-middle>>>a {
  line-height: 1.7rem;
}

.footer-box-middle>>>a:first-child {
  margin-top: 0.4rem;
}

.footer-box:last-child {
  height: 200px;
  width: 43%;
  font: var(--small_mono);
  border-top: 1px solid black;
  padding: 1%;
  line-height: 1.7rem;
}

.logo {
  width: var(--c11);
  margin: 0 auto;
  display: block;
  padding: 1rem;
}

.description {
  font: var(--small_mono);
  letter-spacing: 0.03em;
  margin-top: 0.4rem;
}

@media (max-width: 1000px) {
  .footer-box-middle {
    display: none;
  }

  .footer-box:last-child {
    display: none;
  }

  .footer-box {
    width: 100%;
    padding: 30px;
    height: 100px;

  }
}


@media (max-width: 800px) {
  .description {
    margin-top: 0;
  }
}
</style>

<style>
.invert .Footer {
  color: #fff;
}
</style>
